import React from "react"
import { useState } from "react"
import { Tab, Tabs, OverlayTrigger, Tooltip } from "react-bootstrap"
import { FormattedMessage } from "react-intl"

type TooltipDetails = {
    id: string
    text: FormattedMessage | string
    placement: "top" | "bottom" | "left" | "right"
}

export type TabDetails = {
    component: JSX.Element
    label: FormattedMessage | string | JSX.Element
    disabled: boolean
    tooltipDetails?: TooltipDetails
}

type OwnProps = {
    tabsMapping: Map<string, TabDetails>
    defaultTabKey: string
}

const CustomTabs = (props: OwnProps) => {
    const [activeKey, setActiveKey] = useState(props.defaultTabKey)

    const getTab = (tabKey: string): TabDetails | null => {
        const tab = props.tabsMapping.get(tabKey)
        if (!tab) {
            return null
        }
        return tab
    }

    const getTabComponent = (tabKey: string): JSX.Element => {
        const tab = getTab(tabKey)
        if (!tab) {
            return <></>
        }
        return tab.component
    }

    return (
        <>
            < Tabs activeKey={activeKey} className={"pt-2"} onSelect={k => setActiveKey(k as string)} >
                {
                    Array.from(props.tabsMapping.keys()).map((tabKey, i) => {
                        const tab = getTab(tabKey)
                        if (!tab) {
                            return <></>
                        }

                        if (!tab.tooltipDetails) {
                            return <Tab
                                key={i}
                                eventKey={tabKey}
                                title={tab.label}
                                disabled={tab.disabled}
                            />
                        }

                        const eventKey = tab.disabled ? undefined : tabKey

                        return <Tab
                            key={i}
                            eventKey={eventKey}
                            title={
                                <OverlayTrigger
                                    placement={tab.tooltipDetails.placement}
                                    overlay={
                                        <Tooltip id={tab.tooltipDetails.id}>
                                            {tab.tooltipDetails.text}
                                        </Tooltip>
                                    }
                                >
                                    <span>{tab.label}</span>
                                </OverlayTrigger>
                            }
                        >
                        </Tab>
                    })
                }
            </Tabs >
            {getTabComponent(activeKey)}
        </>
    )
}

export default CustomTabs


// WEBPACK FOOTER //
// ./src/common/tab/CustomTabs.tsx